<script lang="ts">
  import type { ClinicSection } from '@clinic/contracts';
  import { fa } from '../i18n/fa';
  import { tabIndicator } from './tabs';

  /**
   * «همه، کلینیک، لیزر»: narrows a list to one section. Rendered only when there is a choice, i.e.
   * the caller reaches more than one section (the server shows nothing else anyway).
   */
  let {
    options,
    value,
    onChange,
  }: {
    options: readonly ClinicSection[];
    value: ClinicSection | null;
    onChange: (section: ClinicSection | null) => void;
  } = $props();
  const choices = $derived<(ClinicSection | null)[]>([null, ...options]);
</script>

{#if options.length >= 2}
  <div use:tabIndicator role="radiogroup" aria-label={fa.sections.filter} class="tabs w-fit">
    {#each choices as c (c ?? 'all')}
      <button
        type="button"
        role="radio"
        aria-checked={value === c}
        onclick={() => onChange(c)}
        class="tab min-h-8"
        >{c ? fa.sections.names[c] : fa.sections.all}</button
      >
    {/each}
  </div>
{/if}
